import { Label, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';

import { cn } from '@utils/cn';

import { CustomTooltip } from './CustomTooltip';

import type { PieChartsProps } from '../Chart.types';

import { LabelContentStyle, LabelContentTopStyle, LabelTitleStyle } from '../Chart.styles';
import { chartWrapper } from '../Chart.styles';

export const PiesChart = ({ size, label, showLegend, className, ...props }: PieChartsProps) => {
  const textColor = '#737373';
  return (
    <div className={cn(chartWrapper(), className)}>
      <ResponsiveContainer width="100%" height={size?.height || 300}>
        <PieChart {...props.pieChart}>
          <Tooltip content={<CustomTooltip />} />
          <Pie {...props.pie}>
            <Label
              content={({ viewBox }) => {
                if (viewBox && 'cx' in viewBox && 'cy' in viewBox) {
                  return (
                    <text
                      x={viewBox.cx}
                      y={viewBox.cy}
                      textAnchor="middle"
                      dominantBaseline="middle"
                    >
                      <tspan
                        x={viewBox.cx}
                        y={(viewBox.cy || 0) - 24}
                        fill={textColor}
                        className={cn(LabelContentTopStyle(), className)}
                      >
                        {label?.top}
                      </tspan>
                      <tspan
                        x={viewBox.cx}
                        y={viewBox.cy}
                        className={cn(LabelTitleStyle(), className)}
                      >
                        {label?.center}
                      </tspan>
                      <tspan
                        x={viewBox.cx}
                        y={(viewBox.cy || 0) + 24}
                        fill={textColor}
                        className={cn(LabelContentStyle(), className)}
                      >
                        {label?.bottom}
                      </tspan>
                    </text>
                  );
                }
              }}
            />
          </Pie>
          {showLegend && <Legend {...props.legend} />}
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};
